import { useEffect } from "react";
import { Link } from "react-router-dom";
import Lenis from "lenis";
import { Hero } from "@/sections/Hero";
import { Logo } from "@/components/Logo";

export default function SqueezePage() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let id;
    const raf = (time) => {
      lenis.raf(time);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <main data-testid="squeeze-page" className="bg-ink">
      <Hero />
      <footer data-testid="page-footer" className="border-t border-[rgba(163,74,107,0.15)] bg-[#F4E8E4]">
        <div className="mx-auto flex max-w-7xl flex-col items-start gap-6 px-6 py-12 sm:px-10 md:flex-row md:items-center md:justify-between">
          <Logo compact />
          <p className="max-w-md text-xs leading-relaxed text-mutedlilac">
            Menopause Reclaim Retreat · United Kingdom. A wellbeing and reflection experience, not a medical
            treatment or a substitute for personalised clinical advice.
          </p>
          <div className="flex items-center gap-5">
            <p className="text-xs text-mutedlilac">© {new Date().getFullYear()} Meno Flames &amp; Finesse</p>
            <Link
              to="/admin"
              data-testid="admin-login-link"
              className="rounded-full border border-[rgba(163,74,107,0.25)] px-4 py-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#A34A6B] transition-colors duration-300 hover:bg-white"
            >
              Admin
            </Link>
          </div>
        </div>
      </footer>
    </main>
  );
}
